export const loginPage = {
  pageTitle: 'Inici de sessió',
  mainTitle: 'Comenci la seva construcció amb nosaltres.',
  text: `Per iniciar sessió en el seu compte personal, ha de reservar una trucada per encarregar un projecte. Després d'això, rebrà una contrasenya, que podrà canviar.`,
  btnText: 'Següent',
  popupIncorrectText: `La contrasenya o el nom d'usuari no són correctes`,
};
